import { Box, Grid } from "@mui/material";
import { fetchFilters } from "components/app/App.slice";
import { isEmpty } from "lodash";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { isBookmarked } from "utils/CommonFunctions";
import { pageNames } from "utils/Types";
import NoPlansBanner from "../NoPlansBanner";
import Scroller from "../Scroller/InfiniteScroller";
import Item from "./item";
import { Plan } from "./plans";

interface Props {
  plansList: Plan[];
  totalList?: any;
  loadMore?: any;
  suggested?: boolean;
  pageName?: any;
}

function Card(props: Props) {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state: any) => state.app.filters);
  const { plansList, totalList = 0, loadMore, suggested = false, pageName } = props;
  const planShowLoader = useAppSelector((state) => state.plans.planShowLoader);
  const bookmarkShowLoader = useAppSelector((state) => state.bookmarkedPlans.bookmarkShowLoader);

  useEffect(() => {
    if (isEmpty(filters) && !suggested) dispatch(fetchFilters());
  }, [dispatch, filters]);

  return (
    <>
      <Box>
        {plansList.length > 0 ? (
          <Grid
            container
            sx={{
              margin: "8px 0 8px"
            }}
          >
            <Scroller dataLength={plansList.length} loadMore={loadMore} totalList={totalList} label="Plans">
              {plansList.map((item) => {
                return (
                  <React.Fragment key={item.id}>
                    <Item suggested={suggested} item={item} isBookmarked={isBookmarked(item.id)}></Item>
                  </React.Fragment>
                );
              })}
            </Scroller>
          </Grid>
        ) : (
          <>
            {!planShowLoader && !bookmarkShowLoader && !suggested ? (
              <NoPlansBanner pageName={pageName} />
            ) : (
              suggested && <NoPlansBanner pageName={pageNames.noSuggestedFilter} />
            )}
          </>
        )}
      </Box>
    </>
  );
}

export default Card;
